import PropTypes from "prop-types";
import { FlexContainers, Heading5, WrapperContainer } from "../../components";
import { withSection } from "../../hoc";
import {
  BottomContainer,
  HeadingContainer,
  LeftContainer,
  MainContainer,
  MainWrapper
} from "./styled";

const SplittedModalContentTemplate = ({
  title,
  LeftSectionContent,
  BottomSectionContent,
  children
}) => {
  return (
    <WrapperContainer
      FlexContainers={FlexContainers.FlexColumnStart}
      width={"100%"}
      height={"100%"}>
      <HeadingContainer Container={FlexContainers.FlexRowStart}>
        <Heading5>{title}</Heading5>
      </HeadingContainer>

      <MainWrapper Container={FlexContainers.FlexRowStart}>
        {LeftSectionContent && <LeftContainer>{LeftSectionContent}</LeftContainer>}
        <WrapperContainer Container={FlexContainers.FlexColumnStart} width={"100%"} height={"100%"}>
          <MainContainer hasBottomContent={!!BottomSectionContent}>{children}</MainContainer>

          {BottomSectionContent && <BottomContainer>{BottomSectionContent}</BottomContainer>}
        </WrapperContainer>
      </MainWrapper>
    </WrapperContainer>
  );
};

SplittedModalContentTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  LeftSectionContent: PropTypes.node,
  BottomSectionContent: PropTypes.node,
  children: PropTypes.node.isRequired
};

export default withSection(SplittedModalContentTemplate);
